// extracted by mini-css-extract-plugin
export default {"team":"Team_team__V79xA","swiper":"Team_swiper__yqVqf"};